<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="10.585" height="9.733" viewBox="0 0 10.585 9.733">
		<g transform="translate(1.392 1.398)">
			<path
				d="M.5,6.261,2.137,8.623a.621.621,0,0,0,.207.192.541.541,0,0,0,.519.009.614.614,0,0,0,.209-.18L8.295,1.55"
				transform="translate(-0.5 -1.55)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
			/>
		</g>
	</svg>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
export default defineComponent({
	name: 'CheckIcon',
	props: {
		color: {
			type: String,
			default: '#fff',
		},
	},
});
</script>
